export const scrollDashboardToTop = () => {
  document.getElementById('dashboard-content')?.scrollTo({ top: 0 })
}
